export const URL_VALIDATION_REGEX =
  /^(https?:\/\/)?(www\.)?([a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)+)(\/[^\s]*)?$/;

export const CONTACT_VALIDATION_REGEX = /^\d{4}-\d{7}$/;
